export const config = {
  rowSelection: false,
  columns: [
    {
      title: '收款规则ID',
      dataIndex: 'payRuleId',
      width: 200,
    },
    {
      title: '收款规则名称',
      dataIndex: 'ruleName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '适用门店',
      dataIndex: 'orgName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '开始时间',
      dataIndex: 'startDate',
      itemType: 'date',
      width: 180,
    },
    {
      title: '结束时间',
      dataIndex: 'endDate',
      itemType: 'date',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  searchTypeWidth: 160,
  search: [
    {
      name: 'payRuleId',
      label: '收款规则ID',
    },
    {
      name: 'ruleName',
      label: '收款规则名称',
      labelProps: {
        width: 40,
      },
    },
    {
      name: 'orgId',
      label: '适用门店',
      itemType: 'select',
      data: 'companyList',
      key: 'id',
      labelKey: 'name',
    },
  ],
  footer: [
    {
      label: '新增收款规则配置',
      // auth: 'priceButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
}
